import { useAuthHeader } from 'react-auth-kit';

export function useAccessToken() {
  const authHeader = useAuthHeader();
  return authHeader();
}
